// Test IDs for the KesarOne CRM feature set.
// Keys camelCase, values kebab-case shaped as `<feature>-<element>`.

export const AUTH = {
  googleBtn: 'auth-google-signin-button',
  otpInput: 'auth-otp-input',
  otpVerifyBtn: 'auth-otp-verify-button',
  otpResendBtn: 'auth-otp-resend-button',
  geoRetryBtn: 'auth-geo-retry-button',
  logoutBtn: 'auth-logout-button',
};

export const NAV = {
  dashboard: 'nav-dashboard',
  bookings: 'nav-bookings',
  inventory: 'nav-inventory',
  customers: 'nav-customers',
  accounts: 'nav-accounts',
  recentPayments: 'nav-recent-payments',
  recovery: 'nav-recovery',
  legal: 'nav-legal',
  legalCalendar: 'nav-legal-calendar',
  loan: 'nav-loan',
  pricingTracker: 'nav-pricing-tracker',
  reports: 'nav-reports',
  approvals: 'nav-approvals',
  eoiHub: 'nav-eoi-hub',
  eoiPunch: 'nav-eoi-punch',
  admin: 'nav-admin',
};

export const DASH = {
  kpiBookings: 'dash-kpi-bookings',
  kpiDealValue: 'dash-kpi-deal-value',
  kpiCollected: 'dash-kpi-collected',
  kpiOverdue: 'dash-kpi-overdue',
  bookingsTable: 'dash-bookings-table',
  newBookingBtn: 'dash-new-booking-button',
  exportBtn: 'dash-export-button',
  bookingRow: 'dash-booking-row',
};

export const BOOKING = {
  wizard: 'booking-wizard',
  nextBtn: 'booking-next-button',
  backBtn: 'booking-back-button',
  submitBtn: 'booking-submit-button',
  primaryApplicant: 'booking-primary-applicant',
  projectSelect: 'booking-project-select',
  unitSelect: 'booking-unit-select',
  fundingType: 'booking-funding-type',
  sourceType: 'booking-source-type',
  dealValue: 'booking-deal-value',
  addMilestoneBtn: 'booking-add-milestone-button',
  scheduleRemaining: 'booking-schedule-remaining',
  cancelBtn: 'booking-cancel-button',
  cancelReason: 'booking-cancel-reason',
  cancelConfirm: 'booking-cancel-confirm',
  detail: 'booking-detail',
};

export const EOI = {
  page: 'eoi-approvals-page',
  hubPage: 'eoi-hub-page',
  row: 'eoi-row',
  reviewBtn: 'eoi-review-button',
  reviewModal: 'eoi-review-modal',
  consentBtn: 'eoi-consent-button',
  flagBtn: 'eoi-flag-button',
  flagNote: 'eoi-flag-note-input',
  flagSubmit: 'eoi-flag-submit-button',
  approveBtn: 'eoi-approve-button',
  rejectBtn: 'eoi-reject-button',
  rejectReason: 'eoi-reject-reason-input',
  rejectSubmit: 'eoi-reject-submit-button',
};

export const BOOKINGS = {
  page: 'bookings-page',
  table: 'bookings-table',
  row: 'bookings-row',
};

export const REPORTS = {
  page: 'reports-page',
  cashflow: 'reports-cashflow',
  velocity: 'reports-velocity',
  recovery: 'reports-recovery',
};

export const ADMIN = {
  usersTab: 'admin-users-tab',
  geofenceTab: 'admin-geofence-tab',
  auditTab: 'admin-audit-tab',
  securityTab: 'admin-security-tab',
  addUserBtn: 'admin-add-user-button',
  saveUserBtn: 'admin-save-user-button',
  addGeofenceBtn: 'admin-add-geofence-button',
  saveGeofenceBtn: 'admin-save-geofence-button',
  emailLogTab: 'admin-email-log-tab',
};

export const ACCT = {
  addPaymentBtn: 'accounts-add-payment-button',
  savePaymentBtn: 'accounts-save-payment-button',
  paymentsTable: 'accounts-payments-table',
  clearBtn: 'cheque-clear-button',
  bounceBtn: 'cheque-bounce-button',
  settleConfirm: 'cheque-settle-confirm-button',
  bounceReason: 'cheque-bounce-reason-input',
  recentPage: 'recent-payments-page',
  recentTable: 'recent-payments-table',
  recentRow: 'recent-payment-row',
  windowFilter: 'recent-window-filter',
};

export const ENGAGE = {
  bell: 'notif-bell',
  badge: 'notif-badge',
  item: 'notif-item',
  commentInput: 'comment-input',
  commentSubmit: 'comment-submit',
  mentionOption: 'mention-option',
  thread: 'comment-thread',
};

export const RECOVERY = {
  criticalToggle: 'critical-toggle',
  criticalReason: 'critical-reason-input',
  criticalSave: 'critical-save-button',
  bucketFilter: 'recovery-bucket-filter',
  agingTable: 'recovery-aging-table',
  criticalPanel: 'recovery-critical-panel',
  upcoming: 'recovery-upcoming',
};

export const INV = {
  rlToggle: 'unit-rl-toggle',
  manageCategories: 'manage-categories-button',
  saveCategories: 'save-categories-button',
  unitType: 'unit-type-select',
  plotType: 'unit-plot-type-select',
  projectCategory: 'unit-project-category-select',
  editUnit: 'unit-edit-button',
  saveUnit: 'unit-edit-save-button',
};

export const KYC = {
  pan: 'kyc-pan-upload',
  aadhaar: 'kyc-aadhaar-upload',
  photo: 'kyc-photo-upload',
};

export const LOAN = {
  editBtn: 'loan-edit-button',
  cancelBtn: 'loan-cancel-button',
  advanceBtn: 'loan-advance-stage-button',
};

export const FOLLOWUP = {
  note: 'followup-note-input',
  outcome: 'followup-outcome-select',
  amount: 'followup-amount-input',
  date: 'followup-date-input',
  submit: 'followup-submit-button',
  item: 'followup-item',
  log: 'followup-log',
};

export const FILES = {
  tab: 'booking-files-tab',
  section: 'booking-files-section',
  row: 'file-row',
};

export const LEGAL = {
  rejectBtn: 'legal-reject-button',
  rejectReason: 'legal-reject-reason-input',
  rejectSave: 'legal-reject-save-button',
  thread: 'legal-stage-thread',
};

export const IMMUT = {
  padlock: 'unit-locked-indicator',
  overrideBtn: 'admin-override-button',
  overrideConfirm: 'override-confirm-checkbox',
  overrideReason: 'override-reason-input',
  overrideSendOtp: 'override-send-otp-button',
  overrideOtp: 'override-otp-input',
  overrideSubmit: 'override-submit-button',
};

export const REPLY = {
  btn: 'comment-reply-button',
  input: 'comment-reply-input',
  submit: 'comment-reply-submit',
};

export const CAL = {
  page: 'legal-calendar-page',
  horizonFilter: 'calendar-horizon-filter',
  scheduleBtn: 'calendar-schedule-button',
  dialog: 'calendar-event-dialog',
  bookingSearch: 'calendar-booking-search',
  bookingResult: 'calendar-booking-result',
  eventType: 'calendar-event-type',
  date: 'calendar-event-date',
  time: 'calendar-event-time',
  notes: 'calendar-event-notes',
  submit: 'calendar-event-submit',
  event: 'calendar-event-card',
  editBtn: 'calendar-event-edit',
  cancelBtn: 'calendar-event-cancel',
  cancelReason: 'calendar-cancel-reason',
  cancelConfirm: 'calendar-cancel-confirm',
};

export const DASHWIDGET = {
  legalExec: 'dash-legal-executions',
  legalExecRow: 'dash-legal-exec-row',
  approvals: 'dash-approvals-widget',
  approvalRow: 'dash-approval-row',
  approvalRefresh: 'dash-approvals-refresh',
};

export const APPROVAL = {
  modal: 'approval-modal',
  note: 'approval-note',
  amount: 'approval-amount',
  file: 'approval-file',
  approve: 'approval-approve',
  reject: 'approval-reject',
  execute: 'approval-execute',
};

export const CUSTFILTER = {
  letter: 'customers-letter',
  project: 'customers-project',
};

export const MERGE = {
  openBtn: 'customers-merge-button',
  dialog: 'customers-merge-dialog',
  survivorSearch: 'merge-survivor-search',
  survivorOption: 'merge-survivor-option',
  duplicateSearch: 'merge-duplicate-search',
  duplicateOption: 'merge-duplicate-option',
  confirm: 'merge-confirm-button',
};

export const PRICING = {
  page: 'pricing-tracker-page',
  project: 'pricing-project-select',
  effectiveDate: 'pricing-effective-date',
  rateInput: 'pricing-rate-input',
  publish: 'pricing-publish-button',
  ledgerRow: 'pricing-ledger-row',
  activeRate: 'pricing-active-rate',
};

export const CHARGE = {
  section: 'charges-section',
  postBtn: 'charge-post-button',
  categorySelect: 'charge-category-select',
  amountInput: 'charge-amount-input',
  reasonInput: 'charge-reason-input',
  submitBtn: 'charge-submit-button',
  row: 'charge-row',
  approveBtn: 'charge-approve-button',
  waiveBtn: 'charge-waive-button',
  waiveReason: 'charge-waive-reason-input',
  waiveConfirm: 'charge-waive-confirm-button',
};

export const COAPP = {
  selector: 'coapp-selector',
  addBtn: 'coapp-add-button',
  row: 'coapp-row',
  search: 'coapp-search-input',
  option: 'coapp-option',
  relationship: 'coapp-relationship-select',
  kycBtn: 'coapp-kyc-button',
  removeBtn: 'coapp-remove-button',
  kycDialog: 'coapp-kyc-dialog',
};

export const MIGRATE = {
  page: 'migrate-booking-page',
  entryBtn: 'migrate-entry-button',
  bookingDate: 'migrate-booking-date',
  allotmentDate: 'migrate-allotment-date',
  afsDate: 'migrate-afs-date',
  milestonePaid: 'migrate-milestone-paid',
  milestoneCollectedDate: 'migrate-milestone-collected-date',
  milestoneCollectedAmount: 'migrate-milestone-collected-amount',
  submitBtn: 'migrate-submit-button',
  legacyBadge: 'booking-legacy-badge',
};
